<template>
  <div class="mt-6 text-[#001c54]">
    <div class="text-base">
      <span class="mr-2 inline-flex h-6 w-6 items-center justify-center rounded-full bg-red-500 align-middle text-sm font-bold text-white">!</span>
      <span class="font-bold text-red-600">Note:</span> One-time registration fee: ₹1,500.
    </div>
    <div class="mt-5 mb-3 text-lg font-bold lg:text-xl">Applicable examination fee per year:</div>
    <div class="mx-auto max-w-2xl divide-y divide-[#BDE6F7] rounded-lg border border-[#BDE6F7] bg-[#EEF6F9] text-left text-base font-semibold">
      <div v-for="fee in fees" :key="fee.label" class="flex justify-between gap-4 px-5 py-3 lg:px-12">
        <span>{{ fee.label }}</span>
        <span>{{ fee.amount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // Set to false on pages that don't offer the programme to international students.
    international: { type: Boolean, default: true },
  },
  computed: {
    fees() {
      const fees = [
        { label: "For Indian students:", amount: "₹3,000" },
        { label: "For SAARC students:", amount: "₹3,000" },
      ];
      if (this.international) {
        fees.push({ label: "For International students:", amount: "$50" });
      }
      return fees;
    },
  },
};
</script>
